import React from "react";
import { PublicMapComponent } from "./components/public-map";

export const App: React.FunctionComponent = () => <PublicMapComponent />;
